import script from "./BlogCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogCard.vue?vue&type=script&setup=true&lang=ts"

import "./BlogCard.vue?vue&type=style&index=0&id=968bc132&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-968bc132"]])

export default __exports__